export default __webpack_public_path__ + "static/media/AvenirNextW04-Bold.e8ed7684.woff2";